import React, { useState, useEffect } from 'react';
import { User } from '../../types';
import { usersAPI } from '../../services/api';
import Layout from '../../components/layout/Layout';
import UserManagement from '../../components/admin/UserManagement';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import toast from 'react-hot-toast';

const Users: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      setIsLoading(true);
      const usersData = await usersAPI.getAll();
      setUsers(usersData);
    } catch (error) {
      console.error('Error loading users:', error);
      toast.error('Failed to load users');
    } finally {
      setIsLoading(false);
    }
  };

  const handleUsersChange = (updatedUsers: User[]) => {
    setUsers(updatedUsers);
  };

  if (isLoading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-64">
          <LoadingSpinner size="lg" />
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-7xl mx-auto">
        <UserManagement users={users} onUsersChange={handleUsersChange} />
      </div>
    </Layout>
  );
};

export default Users;
